import * as types from './notificationActionTypes.js';

export const setCounter = () => ({ type: types.SET_COUNTER });
export const resetCounter  = () => ({ type: types.RESET_COUNTER });